import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import { environment } from './environments/environment'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek'
import dayjs from 'dayjs'

dayjs.extend(customParseFormat)
dayjs.extend(isoWeek)

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/serviceWorker.js')
    .then(reg => console.log('SW registrato:', reg))
    .catch(err => console.error('Errore SW:', err))
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.log(err))
